import React, { useCallback } from 'react'
import { SolidButton } from 'react-components'

import {
    CustomerSupportFooterSectionContainer,
    Title,
    Subtitle,
    ContactContainer,
    ContactNumberContainer,
    ContactNumber,
    ContactEmailContainer,
    ContactEmail,
    ButtonContainer,
} from './customer-support-footer-section-styles'
import { CustomerSupportFooterSectionTransport } from '@common/transports/deprecated-home-page-transport'
import { AnalyticsService } from '@src/services'
import { homePageEventCategories } from '@src/services/analytics-service/categories'

interface CustomerSupportFooterSectionProps {
    customerSupportFooterSection: CustomerSupportFooterSectionTransport
    isLoggedIn: boolean
}

const CustomerSupportFooterSection: React.FC<CustomerSupportFooterSectionProps> = ({
    customerSupportFooterSection: { id, title, subtitle, contact, dashboardButton, registerButton },
    isLoggedIn,
}) => {
    const buttonToRender = isLoggedIn ? dashboardButton : registerButton

    const _handlePhoneClick = useCallback(() => {
        if (contact.phone.eventLabel) {
            AnalyticsService.trackClickEvent(
                homePageEventCategories.CUSTOMER_SUPPORT_FOOTER_SECTION,
                contact.phone.eventLabel,
            )
        }
    }, [contact.phone])

    const _handleEmailClick = useCallback(() => {
        if (contact.email.eventLabel) {
            AnalyticsService.trackClickEvent(
                homePageEventCategories.CUSTOMER_SUPPORT_FOOTER_SECTION,
                contact.email.eventLabel,
            )
        }
    }, [contact.email])

    const _handleCTAButtonClick = useCallback(() => {
        if (buttonToRender === registerButton && buttonToRender.eventLabel) {
            AnalyticsService.trackClickEvent(
                homePageEventCategories.CUSTOMER_SUPPORT_FOOTER_SECTION,
                buttonToRender.eventLabel,
            )
        }
    }, [buttonToRender, registerButton])

    return (
        <CustomerSupportFooterSectionContainer id={id}>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
            <ContactContainer>
                <ContactNumberContainer>
                    <ContactNumber href={contact.phone.url} onClick={_handlePhoneClick}>
                        {contact.phone.text}
                    </ContactNumber>
                </ContactNumberContainer>
                <ContactEmailContainer>
                    <ContactEmail href={contact.email.url} target={'_blank'} onClick={_handleEmailClick}>
                        {contact.email.text}
                    </ContactEmail>
                </ContactEmailContainer>
            </ContactContainer>
            <ButtonContainer>
                <SolidButton
                    borderRadius="0.375rem"
                    padding="0.625rem 1.25rem"
                    href={buttonToRender.url}
                    onClick={_handleCTAButtonClick}
                >
                    {buttonToRender.text}
                </SolidButton>
            </ButtonContainer>
        </CustomerSupportFooterSectionContainer>
    )
}

export default CustomerSupportFooterSection
